// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"8bf1531a","453":"2ccedc29","674":"78d743ba","945":"56eb0a3f","961":"a86af073"}[chunkId] + ".chunk.js";
};